import { Alert } from "bootstrap";
import React, { useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";

import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import api from "../../../../../service/api";
import FormRow from "./FormRow";
import { Button } from "react-bootstrap";
import { Eye } from "react-feather";
import ItemModal from "../ItemModal";
const AddEditMcpQuotation = () => {
    let { id } = useParams();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const [quotation, setQuotation] = useState();
    const [courseFee, setCourseFee] = useState();
    const [adhocCourseFees, setAdhocCourseFees] = useState();
    const [configValues, setConfigValues] = useState({
        tradeOptions: [],
        tradeCategory: [],
        tradeApplication: [],
        atoCourses: [],
        attcCourses: [],
        companies: [],
        departments: [],
        location: [],
    });
    const [selectedItem, setSelectedItem,] = useState({show: false});

    const setCourseData = (data) => {
        const formatAto = data
            .filter((data, index) => {
                return data?.type?.toUpperCase() === "ATO";
            })
            .map((data, index) => {
                return { value: data.id, label: data.name };
            });
        const formatAttc = data
            .filter((data, index) => {
                return data?.type?.toUpperCase() === "ATTC";
            })
            .map((data, index) => {
                return { value: data.id, label: data.name };
            });
        const { atoCourses, attcCourses } = { ...configValues };
        atoCourses.push(...formatAto);
        attcCourses.push(...formatAttc);
        setConfigValues({ atoCourses, attcCourses });
    };

    const setCompanyData = (data) => {
        const formatData = data.map((data, index) => {
            return { value: data.id, label: data.name };
        });
        const { companies } = { ...configValues };
        companies.push(...formatData);
        setConfigValues(companies);
    };

    const handleClose = () => setSelectedItem({show: false});
    const handleShow = () => setSelectedItem(
        {
            show: true,
            // index: index,
            // course_code: course,
        }
    );

    /** use effect */
    useEffect(() => {
        const getConfig = async () => {
            try {
                setLoading(true);
                const configResponse = await api.get(
                    `tms/sales-quotations/config`,
                    {}
                );
                const courseResponse = await api.get(`tms/courses?all=1`, {});
                const courseFeeResponse = await api.get("tms/get_course_fee");
                const adhocCourseFeeResponse = await api.get("tms/get_course_fee/additional-items");
                // console.log(courseFeeResponse.data);
                // const companyResponse = await api.get(
                //     `tms/companies?all=1`,
                //     {}
                // );
                setAdhocCourseFees(adhocCourseFeeResponse?.data);
                setCourseData(courseResponse?.data);
                setCourseFee(courseFeeResponse.data);
                setConfigValues({ ...configValues, ...configResponse.data });
                setLoading(false);
            } catch (error) {
                setError(error.message);
            }
        };
        if (id && id !== "add") {
            const getQuotation = async () => {
                try {
                    setLoading(true);
                    const response = await api.get(
                        `tms/sales-quotations/${id}`,
                        {}
                    );
                    setQuotation(response.data);
                    setLoading(false);
                } catch (error) {}
            };
            getQuotation();
        }
        getConfig();
    }, [id]); //  eslint-disable-line react-hooks/exhaustive-deps
    const helmetTitle = `${id !== "add" ? "Edit" : "Create"} Pre-Booking Quotations`;
    return (
        <React.Fragment>
            <Helmet title={helmetTitle} />
            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                        <h1 className="text-xl font-bold">
                            {helmetTitle}
                        </h1>
                        <div>
                            <Button
                                variant="secondary"
                                onClick={handleShow}
                                className="mt-1 me-2"
                            >
                                <Eye size={15} /> Item List
                            </Button>
                        </div>
                </div>
                <Card className="m-0 p-0">
                    <Card.Body>
                        {error && (
                            <Alert className="my-3" variant="danger">
                                <div className="alert-message">{error}</div>
                            </Alert>
                        )}
                        {loading && <div>Loading...</div>}
                        {!loading && (
                            <FormRow
                                adhocCourseFees={adhocCourseFees}
                                configValues={configValues}
                                quotation={quotation}
                                courseFee={courseFee}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Container>
            <ItemModal
                handleClose = {handleClose}
                selectedItem = {selectedItem}
                courseFee = {courseFee}
            /> 
        </React.Fragment>
    );
};

export default AddEditMcpQuotation;
